module.exports = __webpack_public_path__ + "static/media/application.d415d11e.svg";